__turbopack_context__.v({
  "checkLabel": "CartPage-module-scss-module__ODyQvq__checkLabel",
  "checkbox": "CartPage-module-scss-module__ODyQvq__checkbox",
  "clearBtn": "CartPage-module-scss-module__ODyQvq__clearBtn",
  "count": "CartPage-module-scss-module__ODyQvq__count",
  "deleteBtn": "CartPage-module-scss-module__ODyQvq__deleteBtn",
  "empty": "CartPage-module-scss-module__ODyQvq__empty",
  "emptyBtn": "CartPage-module-scss-module__ODyQvq__emptyBtn",
  "emptyIcon": "CartPage-module-scss-module__ODyQvq__emptyIcon",
  "emptyText": "CartPage-module-scss-module__ODyQvq__emptyText",
  "freeShipping": "CartPage-module-scss-module__ODyQvq__freeShipping",
  "header": "CartPage-module-scss-module__ODyQvq__header",
  "imagePlaceholder": "CartPage-module-scss-module__ODyQvq__imagePlaceholder",
  "item": "CartPage-module-scss-module__ODyQvq__item",
  "itemCheck": "CartPage-module-scss-module__ODyQvq__itemCheck",
  "itemDate": "CartPage-module-scss-module__ODyQvq__itemDate",
  "itemDimmed": "CartPage-module-scss-module__ODyQvq__itemDimmed",
  "itemImage": "CartPage-module-scss-module__ODyQvq__itemImage",
  "itemInfo": "CartPage-module-scss-module__ODyQvq__itemInfo",
  "itemList": "CartPage-module-scss-module__ODyQvq__itemList",
  "itemName": "CartPage-module-scss-module__ODyQvq__itemName",
  "itemOption": "CartPage-module-scss-module__ODyQvq__itemOption",
  "itemPrice": "CartPage-module-scss-module__ODyQvq__itemPrice",
  "layout": "CartPage-module-scss-module__ODyQvq__layout",
  "left": "CartPage-module-scss-module__ODyQvq__left",
  "orderBtn": "CartPage-module-scss-module__ODyQvq__orderBtn",
  "page": "CartPage-module-scss-module__ODyQvq__page",
  "qty": "CartPage-module-scss-module__ODyQvq__qty",
  "qtyBtn": "CartPage-module-scss-module__ODyQvq__qtyBtn",
  "qtyWrap": "CartPage-module-scss-module__ODyQvq__qtyWrap",
  "removeBtn": "CartPage-module-scss-module__ODyQvq__removeBtn",
  "right": "CartPage-module-scss-module__ODyQvq__right",
  "shimmer": "CartPage-module-scss-module__ODyQvq__shimmer",
  "skeleton": "CartPage-module-scss-module__ODyQvq__skeleton",
  "summary": "CartPage-module-scss-module__ODyQvq__summary",
  "summaryDivider": "CartPage-module-scss-module__ODyQvq__summaryDivider",
  "summaryRow": "CartPage-module-scss-module__ODyQvq__summaryRow",
  "summaryTitle": "CartPage-module-scss-module__ODyQvq__summaryTitle",
  "summaryTotal": "CartPage-module-scss-module__ODyQvq__summaryTotal",
  "title": "CartPage-module-scss-module__ODyQvq__title",
  "toolbar": "CartPage-module-scss-module__ODyQvq__toolbar",
});
